<template>
  <iColumn align="center">
    <iSubHeading
      variant="standard"
    >
      Let's get you set up. Enter your details below.
    </iSubHeading>
    <iTextInput
      v-model="userAuthEmail"
      placeholder="Email"
      disabled
      width="fill"
    />
    <iTextInput
      v-model="userFirstName"
      placeholder="First Name"
      width="fill"
      focus
    />
    <iTextInput
      v-model="userLastName"
      placeholder="Last Name"
      width="fill"
    />
    <iTextInput
      v-model="password"
      placeholder="Password"
      width="fill"
      type="password"
    />
    <PasswordComplexity
      v-if="password"
      :password="password"
      @update:password="validatePasswordComplexity"
    />
    <iTextInput
      v-model="confirmPassword"
      placeholder="Confirm Password"
      width="fill"
      type="password"
      @enter="completeSignUp"
    />
    <iText v-if="signupErrorMessage" variant="error">
      {{ signupErrorMessage }}
    </iText>
    <iButton
      :is-loading="isLoading"
      loading-spinner-position="inside"
      :disabled="isLoading || !validPassword"
      @click="completeSignUp"
    >
      Continue
    </iButton>
    <iSpace :height="40" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "@/components/join-publication/PoweredByInspiration";
import { mapActions, mapState, mapWritableState } from "pinia";
import PasswordComplexity from "@/components/PasswordComplexity.vue";
import { useUserStore } from "@/stores/user-store";

export default {
  name: "JoinPublicationCompleteAccount",
  components: { PasswordComplexity, PoweredByInspiration },
  data() {
    return {
      validPassword: false,
      password: "",
      confirmPassword: "",
    };
  },
  computed: {
    ...mapWritableState(useUserStore, [
      "userAuthEmail",
      "userFlowSteps",
      "userFirstName",
      "userLastName",
      "signupErrorMessage",
    ]),
    ...mapState(useUserStore, [
      "isLoading",
    ]),
    isSignupFormValid() {
      return this.validateSignupFormData(
        this.firstName,
        this.lastName,
        this.userAuthEmail,
        this.password,
        this.confirmPassword,
      );
    },
  },
  mounted() {
    this.signupErrorMessage = "";
  },
  methods: {
    ...mapActions(useUserStore, [
      "signUpAndAcceptInvitation",
      "validateSignupFormData",
    ]),
    completeSignUp() {
      if (!this.isSignupFormValid) {
        return;
      }
      this.signUpAndAcceptInvitation(this.password);
    },
    validatePasswordComplexity(value) {
      this.validPassword = value;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
